export default __webpack_public_path__ + "static/media/LightBackground.329ed796.png";